import { render, staticRenderFns } from "./IconStorefront.vue?vue&type=template&id=6cdafc9a"
import script from "./IconStorefront.vue?vue&type=script&lang=js"
export * from "./IconStorefront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports